export default __webpack_public_path__ + "static/img/wp_contact_2.b783514.jpg";